/* Boutons « Aide à la mesure » qui reprennent celui de la fiche (snippets/kt-measure-button.liquid, attribut
   data-kt-measure-mirror) : pied du guide des tailles, bloc d'« Image with text ». La source est le premier bouton de
   la page qui n'en recopie pas un autre : le bloc de Product information, sinon la section. Avec « button », seul le
   bouton est recopié (libellé, style, largeur, icône) et l'alignement reste celui de l'endroit ; avec « all »,
   l'alignement suit aussi. Sans source, chaque bouton garde le sien. Recopié au chargement, puis à chaque section
   rechargée par l'éditeur. */
function syncMeasureButtons() {
  const all = [...document.querySelectorAll(".kt-measure-btn")];
  const source = all.find((el) => !el.hasAttribute("data-kt-measure-mirror") && !el.closest("#kt-ms"));
  const button = source && source.querySelector("button[data-kt-measure-open]");
  if (!button) return;
  all.forEach((el) => {
    const mode = el.getAttribute("data-kt-measure-mirror");
    if (!mode) return;
    if (mode === "all") el.className = source.className;
    el.replaceChildren(button.cloneNode(true));
  });
}

syncMeasureButtons();
document.addEventListener("shopify:section:load", syncMeasureButtons);
